module.exports = __webpack_public_path__ + "static/media/popup_avatar.c735e042.svg";